export const currencies = {
  INR: { symbol: "₹", locale: "en-IN", label: "INR" },
  USD: { symbol: "US$", locale: "en-US", label: "USD" },
};

export const packages = [
  {
    id: "launchcheck",
    name: "LaunchCheck",
    price: { INR: 9999, USD: 149 },
    period: null,
    audience: "For small websites, landing pages, and simple digital products.",
    timeline: "Typically 3–5 business days after scope confirmation (estimate)",
    includes: [
      "Basic security and configuration checks",
      "Policy presence and consistency review",
      "Speed and technical SEO checks",
      "Responsive and functional testing",
      "Prioritized findings report",
      "Launch checklist",
    ],
    excludes: ["Manual penetration testing", "Legal opinions", "Retesting (available as an add-on)"],
  },
  {
    id: "securelaunch",
    name: "SecureLaunch",
    price: { INR: 24999, USD: 399 },
    period: null,
    audience: "For SaaS products, web applications, and mobile apps.",
    timeline: "Typically 7–12 business days, depending on roles, endpoints and environments (estimate)",
    includes: [
      "Expanded security assessment",
      "API and access control checks",
      "Infrastructure configuration review",
      "Performance assessment",
      "Third-party dependency review",
      "Remediation recommendations",
      "Retesting within the agreed scope",
    ],
    excludes: ["Formal certification or attestation", "Source code review unless scoped", "Legal opinions"],
  },
  {
    id: "compliancecheck",
    name: "ComplianceCheck",
    price: { INR: 19999, USD: 299 },
    period: null,
    audience: "For privacy, policy, and regulatory readiness.",
    timeline: "Typically 5–10 business days, depending on target countries (estimate)",
    includes: [
      "Applicable requirements mapping",
      "Privacy and cookie assessment",
      "Website and application policy review",
      "E-commerce disclosure review where relevant",
      "Country-specific gap report",
      "Documentation checklist",
      "Legal specialist referrals where required",
    ],
    excludes: ["Legal advice or legal opinions", "Regulator filings or registrations", "Security testing"],
  },
  {
    id: "golive360",
    name: "GoLive360",
    flagship: true,
    price: { INR: 49999, USD: 799 },
    period: null,
    audience: "The flagship comprehensive pre-launch assessment.",
    timeline: "Typically 12–20 business days, including one retest cycle (estimate)",
    includes: [
      "Relevant security checks",
      "Privacy and compliance readiness",
      "Policies and disclosures",
      "Performance and infrastructure review",
      "Functional and accessibility testing",
      "Payment workflow checks where applicable",
      "Risk prioritization",
      "Remediation roadmap",
      "Final retesting within the agreed scope",
      "Final readiness report",
    ],
    excludes: ["Guarantee of security or compliance", "Formal certification", "Unlimited retest cycles"],
  },
  {
    id: "continuousguard",
    name: "ContinuousGuard",
    price: { INR: 14999, USD: 249 },
    period: "month",
    audience: "For ongoing, scheduled assurance after launch.",
    timeline: "Monthly cycle with a written report; minimum term agreed in the proposal",
    includes: [
      "Scheduled security and configuration reviews",
      "Uptime and certificate monitoring setup or review",
      "Dependency checks",
      "Performance checks",
      "Periodic policy and compliance reviews",
      "Change-related risk assessments",
      "Monthly report and recommendations",
    ],
    excludes: [
      "24/7 monitoring or incident response (not included unless separately contracted and staffed)",
      "Managed security operations",
    ],
    note:
      "ContinuousGuard sets up or reviews your monitoring tooling and runs scheduled reviews. It is not a continuously staffed monitoring service.",
  },
];

export const addOns = [
  { name: "Additional domain or subdomain", price: { INR: 4999, USD: 79 } },
  { name: "Additional web or mobile application", price: { INR: 14999, USD: 249 } },
  { name: "Additional API (per API surface)", price: { INR: 7999, USD: 129 } },
  { name: "Additional target country", price: { INR: 5999, USD: 99 } },
  { name: "Additional retest cycle", price: { INR: 6999, USD: 119 } },
];

export const pricingNotes = [
  "All prices are starting prices. Final fees depend on the agreed scope, complexity, environments and timelines and are confirmed in a written proposal.",
  "USD figures are reference prices. The actual quote depends on scope and the agreed billing currency.",
  "Indian taxes (such as GST) are applied as required by law and shown on the proposal and invoice.",
  "Rigorfield does not provide legal opinions. Where legal interpretation is needed we will recommend you consult a qualified legal professional.",
  "Penetration testing is performed only within an explicitly authorised, written scope.",
  "Assessments do not constitute a formal certification, accreditation or government approval, and do not guarantee security, compliance or search rankings.",
  "No online payment is taken on this website. Engagements are invoiced after a proposal is accepted.",
];

export const formatPrice = (pkg, cur) => {
  const c = currencies[cur];
  const n = new Intl.NumberFormat(c.locale).format(pkg.price[cur]);
  return `${c.symbol}${n}`;
};
